import { hasPermission } from 'src/utils'

export default [
  {
    id: 'I01',
    name: 'Importação de arquivo AFD',
    description: '',
    show: hasPermission({module: 'importafd', action: 'post'})
  },
  {
    id: 'I02',
    name: 'Importação de arquivo de escalas',
    description: '',
    show: hasPermission({module: 'importescalas', action: 'post'})
  }
]
